import "./CompanyStatisticsComponent.scss";
import template from "./CompanyStatisticsComponent.html";
import {IComponentOptions} from "angular";
import {CodeAndExchange, securityEquality} from "../../../instruments/types/CodeAndExchange";
import {Observable, ReplaySubject} from "rxjs";
import {CompanyStatisticsViewModel} from "./models/CompanyStatisticsViewModel";
import {IndustryGroup} from "../../../instruments/industry-group/types/IndustryGroup";
import {IsoDate} from "../../../pseudo-types/DateTypes";
import {CompanyStatisticsStore} from "../../store/statistics/CompanyStatisticsStore";
import {PriceStrategy} from "../../../components/inputs/price/input/PriceStrategy";
import {PriceStrategyService} from "../../../components/inputs/price/service/PriceStrategyService";

export const CompanyStatistics = "tfCompanyStatistics";

export function companyStatistics(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<"
        },
        controllerAs: "ctrl",
        controller: CompanyStatisticsComponentController
    };
}

export class CompanyStatisticsComponentController {

    public priceStrategy: PriceStrategy;

    /** @input */
    public set security(security: CodeAndExchange | null) {
        if (security != null) {
            this.security$.next(security);
            this.priceStrategy = this.priceStrategyService.forCode(security.code);
        }
    }

    private readonly security$ = new ReplaySubject<CodeAndExchange>(1);

    public readonly sector$: Observable<IndustryGroup | null>;
    public readonly yearLow$: Observable<number | null>;
    public readonly yearHigh$: Observable<number | null>;
    public readonly marketCap$: Observable<number | null>;
    public readonly nextDividendDate$: Observable<IsoDate | null>;
    public readonly nextDividendValue$: Observable<number | null>;
    public readonly earningsPerShare$: Observable<number | null>;
    public readonly peRatio$: Observable<number | null>;

    private readonly model$: Observable<CompanyStatisticsViewModel>;

    /** @ngInject */
    public constructor(private readonly companyStatisticsStore: CompanyStatisticsStore,
                       private readonly priceStrategyService: PriceStrategyService) {
        this.model$ = this.buildModel();
        this.sector$ = this.model$.map((m) => m.industryGroup);
        this.yearLow$ = this.model$.map((m) => m.yearLow);
        this.yearHigh$ = this.model$.map((m) => m.yearHigh);
        this.marketCap$ = this.model$.map((m) => m.marketCap);
        this.nextDividendDate$ = this.model$.map((m) => m.nextDividendDate);
        this.nextDividendValue$ = this.model$.map((m) => m.nextDividendValue);
        this.earningsPerShare$ = this.model$.map((m) => m.earningsPerShare);
        this.peRatio$ = this.model$.map((m) => m.peRatio);
    }

    private buildModel(): Observable<CompanyStatisticsViewModel> {
        return this.security$
                   .distinctUntilChanged(securityEquality())
                   .switchMap((security) => this.companyStatisticsStore.stream(security))
                   .publishReplay(1)
                   .refCount();
    }
}
